module.exports = __webpack_public_path__ + "img/sell.52547a3c.png";